import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { deleteProducts as deleteProductsQuery } from '../query-api'

export interface UseDeleteProductsProps {
  onSuccess?: () => void
  onError?: (error: APIError) => void
}

export const useDeleteProducts = ({ onSuccess, onError }: UseDeleteProductsProps) => {
  const {
    mutate,
    isLoading: isProcessing,
    ...rest
  } = useMutation(deleteProductsQuery, {
    onSuccess,
    onError,
  })

  return { delete: mutate, isProcessing, ...rest }
}
